// extracted by mini-css-extract-plugin
export default {"pageLoader":"styles_pageLoader__icaCx","col":"styles_col__8OjcD"};